/**
 * The legal documents a workshop accepts (docs/jogi). The owner accepts them on
 * first sign in and again whenever TERMS_VERSION changes; the acceptance is kept
 * in public.terms_acceptances.
 */
export const TERMS_VERSION = "2026-11-03";

/** terms = general terms and conditions (ÁSZF), dpa = data processing agreement. */
export const TERMS_DOCUMENTS = ["terms", "dpa"] as const;
export type TermsDocument = (typeof TERMS_DOCUMENTS)[number];

/** Whether the accepted rows cover every document in the current version. */
export function termsComplete(accepted: { document: string; version: string }[], version = TERMS_VERSION): boolean {
  return TERMS_DOCUMENTS.every((d) => accepted.some((a) => a.document === d && a.version === version));
}
